import { ReactNode, useLayoutEffect, useState } from 'react';
import { Router } from 'react-router';
import type { BrowserHistory, Update } from 'history';

interface HistoryRouterProps {
  history: BrowserHistory;
  basename?: string;
  children?: ReactNode;
}

export default function HistoryRouter(props: HistoryRouterProps) {
  const { history, basename, children } = props;
  const [state, setState] = useState<Update>({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router basename={basename} location={state.location} navigationType={state.action} navigator={history}>
      {children}
    </Router>
  );
}
